import CONSTANTS from "@/Constants.js";

export function trackEvent(
  name: string,
  metadata?: Record<string, unknown>
): void {
  if (typeof window !== "undefined" && window.pendo?.track) {
    window.pendo.track(name, metadata ?? {});
  }
}

/**
 * The layout an action happened at.
 *
 * The admin portal is responsive, so the same device is mobile at one width and
 * desktop at another — a user agent cannot answer this.
 *
 * The `md` token is read directly rather than through the sanctioned
 * useBreakpoints() composable, which requires an active setup() context: these
 * events all fire from event handlers, and the board's is an Options API
 * method. The non-reactive isBelowMdBreakpoint() is callable here but returns
 * only a boolean, so `layout` would come from matchMedia while `viewport_width`
 * came from innerWidth — two sources that disagree by the scrollbar width. This
 * and the composable compare the same token against the same innerWidth, so the
 * boundary cannot drift between them.
 */
function layoutProperties(): Record<string, unknown> {
  if (typeof window === "undefined") return {};

  const width = window.innerWidth;
  return {
    layout: width < CONSTANTS.BREAKPOINTS.md ? "mobile" : "desktop",
    viewport_width: width
  };
}

/**
 * Track an event that has to be splittable by layout.
 *
 * Every event the mobile-web initiative measures goes through here rather than
 * trackEvent, so the layout stamp is structural instead of a convention each
 * call site has to remember. trackEvent stays untouched: the events outside the
 * initiative keep the exact payloads they have, desktop measurement included.
 */
export function trackMobileWebEvent(
  name: string,
  metadata: Record<string, unknown> = {}
): void {
  trackEvent(name, { ...metadata, ...layoutProperties() });
}
